import {
  useMutation,
  type MutationFunctionOptions,
  type FetchResult,
} from '@apollo/react-hooks';
import { RESET_PASSWORD } from './resetPassword';

export const useResetPassword = (): ((
  options?: MutationFunctionOptions,
) => Promise<FetchResult>) => {
  const [resetPassword] = useMutation(RESET_PASSWORD);

  return resetPassword;
};
